import { ICategoryPermission } from "../../interfaces/ICategoryPermission";

const SuccessCategoryPermissions = "SUCCESS_CATEGORY_PERMISSIONS";

interface ISuccessCategoryPermissions {
    type: typeof SuccessCategoryPermissions;
    payload: {
        permissions: ICategoryPermission[];
    }
}

export type TPermissionAction
    = ISuccessCategoryPermissions;
    //| ISuccessCategoryPermissions
    //| IFailureCategoryPermissions;

export const createSuccessCategoryPermissionAction = (permissions: ICategoryPermission[]): ISuccessCategoryPermissions => ({
    type: SuccessCategoryPermissions,
    payload: { permissions },
});
